import { navigate as navigateTo } from "gatsby";
import querystring from "query-string";

const navigate = (href) => {
  let domain = __GATSBY_MOBX_STORE__.appStore.domain || "";
  let { query, url } = querystring.parseUrl(href || "");
  if (domain !== "" && query.domain === undefined) {
    query.domain = domain;
  }
  if (!url.startsWith("/")) {
    url = "/" + url;
  }
  let urls = [url];
  let querystringstr = querystring.stringify(query);
  if (querystringstr !== "") {
    urls.push(querystringstr);
  }
  navigateTo(urls.join("?"));
};

export default navigate;
